import axios from 'axios';
import { reset } from 'redux-form';
import decode from 'jwt-decode';
import { history } from 'store/history';
/**
 * Import all constants as an object.
 */
import * as actionType from '../../constants/actionType';
//import * as notificationsAction from '../actions/shared/notificationActions';
import appConstant from '../../constants/app';
import * as storage from '../utility/storage';
import { notificationService } from "../notifications/NotificationService"
/**
 * Import all apiAction as an object.
 */
//import * as apiAction from '../actions/apiAction';

let isInProcesss = false;

export const login = ({ username, password }, formName) => {

    return (dispatch) => {
        let promises = [];
        const companiesCode = appConstant.COMPANIES_CODES;
        companiesCode.forEach((comp) => {
            promises.push(authLogin(username, password, comp.code));
        })

        Promise.all(promises).then((values) => {
            let tokens = [];
            for (const [index, value] of values.entries()) {
                if (value.success) {
                    let token = value.receiveObj.access_token;
                    let profile = decode(token);
                    profile["nameid"] = profile[appConstant.nameIdentifierClaim];
                    profile["unique_name"] = profile[appConstant.nameClaim];
                    profile["given_name"] = profile[appConstant.givenNameClaim];
                    profile["role"] = profile[appConstant.roleClaim];
                    tokens.push({ code: value.code, finalResult: value.receiveObj, profile: profile, token: token, index: index });
                }

            }

            if (tokens.length === appConstant.COMPANIES_CODES.length) {

                storage.setLocalStorage(appConstant.TOKENS, tokens);
                storage.setLocalStorage(appConstant.TOKEN, tokens[0]);
                storage.setSessionStorage(appConstant.CompanyCode, tokens[0].code);

                dispatch(loadCompanies(formName));

            }
            else {
                notificationService.sendErrorMessage("Username or password incorrect. Please check your information and try again!!");
                dispatch({
                    type: actionType.LOG_IN_FAILURE,
                    payload: null
                });
            }
        })
            .catch((error) => {

                notificationService.sendErrorMessage("Username or password incorrect. Please check your information and try again!!");
                dispatch({
                    type: actionType.LOG_IN_FAILURE,
                    payload: null
                });

            });
    }
}

const authLogin = (username, password, code) => {
    return new Promise((resolve) => {
        let obj = {
            userName: username,
            password: password,
            grant_type: "password",
            client_id: process.env.REACT_APP_CLIENT_ID,
            scope: code
        }
        const encodedPayload = Object.keys(obj).map(key => key + '=' + obj[key]).join('&');
        axios.post(process.env.REACT_APP_AUTH_URL + '/token', encodedPayload, {
            handlerEnabled: false,
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8',
            }
        }).then((response) => {
            return resolve({ success: true, receiveObj: response.data, code: code })
        })
            .catch((error) => {
                return resolve({ success: false, receiveObj: error, code: code })
            });
    });

}

export const refreshToken = () => {

    let promises = [];
    let tokenList = storage.getLocalStorage(appConstant.TOKENS);

    tokenList.forEach((v) => {
        promises.push(authRefresh(v.finalResult.refresh_token, v.code));
    })

    if (promises.length > 0) {
        Promise.all(promises).then((values) => {
            let tokens = [];
            for (const [index, value] of values.entries()) {
                if (value.success) {

                    let token = value.receiveObj.access_token;
                    let profile = decode(token);
                    profile["nameid"] = profile[appConstant.nameIdentifierClaim];
                    profile["unique_name"] = profile[appConstant.nameClaim];
                    profile["given_name"] = profile[appConstant.givenNameClaim];
                    profile["role"] = profile[appConstant.roleClaim];
                    tokens.push({ code: value.code, finalResult: value.receiveObj, profile: profile, token: token, index: index });
                }
                else {
                    break;
                }
            }
            if (tokens.length > 0) {
                storage.setLocalStorage(appConstant.TOKENS, tokens);
                const token = storage.getLocalStorage(appConstant.TOKEN);
                const result = tokens.filter(w => w.code === token.code);
                storage.setLocalStorage(appConstant.TOKEN, result[0]);
                storage.setSessionStorage(appConstant.CompanyCode, result[0].code);
            }
            isInProcesss = false;
        })
            .catch((error) => {
                isInProcesss = false;
            });
    }
}

const authRefresh = (token, code) => {
    return new Promise((resolve) => {
        let obj = {
            refresh_token: token,
            grant_type: "refresh_token",
            client_id: process.env.REACT_APP_CLIENT_ID,
        }
        const encodedPayload = Object.keys(obj).map(key => key + '=' + obj[key]).join('&');
        axios.post(process.env.REACT_APP_AUTH_URL + '/token', encodedPayload, {
            handlerEnabled: false, 
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8',
            }
        }).then((response) => {
            return resolve({ success: true, receiveObj: response.data, code: code })
        })
            .catch((error) => {
                return resolve({ success: false, receiveObj: error, code: code })
            });
    });

}

export const loadCompanies = (formName) => {
    return (dispatch) => {
        let promises = [];
        let tokens = storage.getLocalStorage(appConstant.TOKENS)

        tokens.forEach((v) => {
            promises.push(getCompanySetting(v.token, v.code));
        })


        if (promises.length > 0) {

            Promise.all(promises).then((values) => {
                let companies = [];
                for (const [index, value] of values.entries()) {
                    if (value.success) {
                        companies.push({ code: value.code, company: value.receiveObj, index: index });
                    }
                }

                if (companies.length === tokens.length) {

                    storage.setLocalStorage(appConstant.COMPANIES, companies);
                    const token = storage.getLocalStorage(appConstant.TOKEN);
                    const result = companies.filter(w => w.code === token.code);
                    storage.setLocalStorage(appConstant.COMPANY, result[0]);
                    dispatch(reset(formName));
                    dispatch({
                        type: actionType.COMPANY_LOAD_SUCCESS,
                        payload: result[0]
                    });
                    dispatch({
                        type: actionType.LOG_IN_SUCCESS,
                        payload: tokens[0]
                    });
                }
                else {
                    notificationService.sendErrorMessage("Error Occurred while loading company setting!!");
                    dispatch({
                        type: actionType.COMPANY_LOAD_FAILURE,
                        payload: null
                    });
                }

            })
                .catch((error) => {
                    notificationService.sendErrorMessage("Error Occurred while loading company setting!!");
                    dispatch({
                        type: actionType.COMPANY_LOAD_FAILURE,
                        payload: null
                    });
                });
        }
    }
}


export const getCompanySetting = (token, code) => {

    return new Promise((resolve, reject) => {
        if (checkToken()) {
            logoutAuthNotification();
        }
        else {
            axios.options(process.env.REACT_APP_API_URL + '/companysettings', {
                handlerEnabled: false,
                headers: {
                    Authorization: `Bearer ${token}`
                }
            }).then((response) => {
                return resolve({ success: true, receiveObj: response.data, code: code })
            })
                .catch((error) => {
                    return resolve({ success: false, receiveObj: error, code: code })
                });
        }
    });
}

export const logoutAuth = (isRedirect = true) => {
    return function (dispatch) {
        dispatch({
            type: actionType.LOG_OUT
        });

        logout();

        if (isRedirect) {
            history.push('/auth/login');
        }
    };
}

export const logout = () => {

    storage.clearAllCache();
}

export const logoutAuthNotification = () => {
    notificationService.sendMessage("", "logout", "");
}

export const checkToken = () => {
    let res = false;
    if (!storage.isTokenExpired()) {
        if (storage.isNeedToRefreshToken()) {
            if (!isInProcesss) {
                isInProcesss = true;
                refreshToken();
            }
        }
    }
    else {
        res = true;
    }
    return res;
}

export const authErrorHandler = (dispatch, error, type) => {
    let errorMessage = (error.data.message) ? error.data.message : error.data;

    if (error.status === 401) {
        errorMessage = 'You are not authorized to do this. Please login and try again.';
    }

    dispatch({
        type,
        payload: errorMessage,
    });
}

export const companyChange = (companyCode, callback) => {

    return (dispatch) => {
        const companies = storage.getLocalStorage(appConstant.COMPANIES);
        const tokens = storage.getLocalStorage(appConstant.TOKENS);
        if (tokens && tokens !== null && companies && companies !== null) {
            const token = tokens.filter(w => w.code === companyCode);
            const result = companies.filter(w => w.code === companyCode);
            if (result.length > 0) {
                storage.setLocalStorage(appConstant.TOKEN, token[0]);
                storage.setLocalStorage(appConstant.COMPANY, result[0]);
                storage.setSessionStorage(appConstant.CompanyCode, companyCode);
                dispatch({
                    type: actionType.LOG_IN_SUCCESS,
                    payload: token[0]
                });
                dispatch({
                    type: actionType.COMPANY_LOAD_SUCCESS,
                    payload: result[0]
                });

                if (callback) {
                    callback()
                }
            }
        }
    }
}

export const getUserDetail = function (companyCode) {
    const tokens = storage.getLocalStorage(appConstant.TOKENS);
    const token = tokens.find(w => w.code === companyCode);
    if (!token || !token.profile) {
        return null;
    }

    return {
        id: token.profile.nameid,
        name: token.profile.given_name,
        affiliateId: token.profile.AffiliateId,
        scope: token.profile.Scope
    };
};

export const getCurrentUser = function () {
    const token = storage.getLocalStorage(appConstant.TOKEN);
    if (!token) {
        return null;
    }

    return {
        id: token.profile.nameid,
        name: token.profile.given_name,
        affiliateId: token.profile.AffiliateId,
        scope: token.profile.Scope
    };
};